import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDrive_1 from '../../../../../libraries/Images/createAConnectionWithDrive_1.png';
import createAConnectionWithDrive_2 from '../../../../../libraries/Images/createAConnectionWithDrive_2.png';
import createAConnectionWithDrive_3 from '../../../../../libraries/Images/createAConnectionWithDrive_3.png';
import createAConnectionWithDrive_4 from '../../../../../libraries/Images/createAConnectionWithDrive_4.png';
import createAConnectionWithDrive_5 from '../../../../../libraries/Images/createAConnectionWithDrive_5.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdrive">
                1.&nbsp;{translate('createaconnectionwithdrive')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Drive" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_2} width="75%" />
            </Zoom>
            <p>Khi bạn nhấp vào "Drive", màn hình lựa chọn tài khoản Google của người dùng sẽ được hiển thị. Vui lòng chọn một tài khoản để sử dụng cho kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Khi bạn chọn một tài khoản, "RPA CLOUD" sẽ yêu cầu quyền truy cập thay cho bạn. Đồng ý cấp quyền truy cập trên cho "RPA CLOUD" và nhấp vào "Cho phép".</p>
            <Zoom>
                <img src={createAConnectionWithDrive_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Drive sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithDrive_5} width="50%"/>
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Drive.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);